import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

export interface NavigateEvent {
    slug: string;
    params: {[key: string]: string} | null;
    href?: string;
}

@Component({
    selector: 'u4-cpp-search-result',
    templateUrl: './search-result.component.html',
})
export class SearchResultComponent {

    @Input() slug: string;
    @Input() result: number;
    @Input() labels: {[key: string]: string};
    @Input() labelName: string;
    @Input() imageUrl: string;

    // optional
    @Input() href: string | null;
    @Input() params: {[key: string]: string} | null;

    @Output() navigate: EventEmitter<NavigateEvent> = new EventEmitter<NavigateEvent>();

    @HostBinding('class.u4-global-search-result') className = true;

    get resultsLabel() {
        if (!this.result) {
            return this.labels['general.no-results'];
        } else if (this.result === -1) {
            return this.labels['general.no-results'];
        }

        return `${this.result} ${this.result === 1 ? this.labels['general.result'] : this.labels['general.results']}`;
    }

    getImageId() {
        return Math.ceil(Math.random() * 100);
    }

}
